import { Button } from '@mgmresorts/mgm-ui';
import { navigate } from 'hookrouter';
import React, { useContext } from 'react';

import { useContent } from '../../../hooks/useContent';
import { useLoadingLabel } from '../../../hooks/useLoadingLabel';
import { useEvent } from '../../../utils/analytics/useEvent';
import { SignUpFormContext } from '../SignUpFormContext';

import { StyledLink } from './styles';

export function CTASection() {
  const trackEvent = useEvent();
  const { processSignUp, isLoading, canProcessSignUp } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  const signUpCTA = useLoadingLabel(isLoading, 'accountCreation.ctaSection.title');
  return (
    <>
      <Button
        label={signUpCTA}
        size='large'
        variant='primary'
        disabled={isLoading || !canProcessSignUp}
        onClick={processSignUp}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            processSignUp();
          }
        }}
        loading={isLoading}
        fullWidth
        type='submit'
      />
      <StyledLink
        label={getContentByPath('accountCreation.ctaSection.backToSignIn')}
        size='large'
        variant='tertiary'
        icon='arrow-left'
        fullWidth
        onClick={async () => {
          await trackEvent(
            'identity – m life registration - back to sign in',
            'back to sign in',
            'mliferegbacktosignin',
            {},
            true,
          );
          navigate('/');
        }}
        onKeyDown={async e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            await trackEvent(
              'identity – m life registration - back to sign in',
              'back to sign in',
              'mliferegbacktosignin',
              {},
              true,
            );
            navigate('/');
          }
        }}
      />
    </>
  );
}

CTASection.displayName = 'CTASectionField';
